import { SignInButton, SignedIn, SignedOut, UserButton } from "@clerk/clerk-react";
import { Logo } from "@the-drop/ui";
import { Link } from "@tanstack/react-router";
import { resolveClerkPublishableKey } from "../clerk-env";

/**
 * Clerk sign-in / account menu on every page when `VITE_CLERK_PUBLISHABLE_KEY` is set.
 * Renders nothing without a key (same as the rest of the app — no `ClerkProvider`).
 */
export function DispensaryTopBar() {
  if (!resolveClerkPublishableKey()) {
    return null;
  }

  return (
    <header className="sticky top-0 z-50 flex h-14 shrink-0 items-center justify-between border-b border-border bg-white px-6">
      <Link to="/" className="text-dark">
        <Logo size="md" tone="dark" />
      </Link>
      <div className="flex items-center gap-2">
        <SignedOut>
          <SignInButton mode="modal">
            <button type="button" className="btn-primary">
              Sign in
            </button>
          </SignInButton>
        </SignedOut>
        <SignedIn>
          <UserButton
            afterSignOutUrl="/"
            appearance={{
              elements: {
                avatarBox: "h-8 w-8",
              },
            }}
          />
        </SignedIn>
      </div>
    </header>
  );
}
